<div id="fileManagerActionBar" class="file-manager-table" *ngIf="isAnyButtonVisible()">
  <div class="file-manager-table-cell action-bar footer-cell">
    <div class="file-manager-table-row">
      <div class="action-bar-section action-bar-summary-section footer-cell">
        <span *ngIf="isFileSelected()" class="action-bar-badge-caption">File Selected</span>
        <span *ngIf="!isFileSelected()" class="action-bar-badge-caption">Folder Selected</span>
      </div>
      <div class="action-bar-section action-bar-button-section footer-cell middle text-center">
        <div *ngFor="let button of getVisibleButtons()" (click)="button.onClick(button)" [soti-tooltip]="button.tooltip()"
          placement="top"
          class="action-bar-button" [ngClass]="{'disabled': button.isDisabled()}">
          <span class="hd-icon {{button.icon()}} icon-lg"></span>
        </div>
      </div>
      <div class="action-bar-section action-bar-summary-section footer-cell"></div>
    </div>
  </div>
</div>
